// Note this will be delete and we should useScrollLock from Drawer component instead

const BODY_LOCK_SCROLL_CLASSES = [
  'overflow-hidden',
  'pointer-events-none',
  'touch-none',
];

const OVERFLOW_ONLY_CLASSES = ['overflow-hidden'];

interface LockScrollOptions {
  onlyOverflow?: boolean;
}

export const clearBodyLockScroll = (): void => {
  document.body.classList.remove(...BODY_LOCK_SCROLL_CLASSES);
};

/**
 * This function will disable only the scroll of the `<body>` by using CSS. The children elements still can be scrolling.
 */
export const enableBodyLockScroll = (options?: LockScrollOptions): void => {
  const classNames = options?.onlyOverflow
    ? OVERFLOW_ONLY_CLASSES
    : BODY_LOCK_SCROLL_CLASSES;
  document.body.classList.add(...classNames);
};

const preventScroll = (event: Event): void => {
  event.preventDefault();
};

const PREVENT_KEYDOWN_KEYS = [
  'arrowup',
  'arrowdown',
  'pageup',
  'pagedown',
  'home',
  'end',
];

// Prevent keyboard scrolling (arrow keys, page up/down)
const preventScrollKeydown = (event: KeyboardEvent): void => {
  const isPreventKeyDown = PREVENT_KEYDOWN_KEYS.some((key) =>
    key.includes(`${event.key}`.toLowerCase())
  );
  if (isPreventKeyDown) {
    preventScroll(event);
  }
};

/**
 * This function will disable all scroll elements in the website by using script. The page will be frozen.
 *
 * **Please use only when you want to disable all scroll element in the website**
 */
export const forceLockScroll = (): void => {
  window.addEventListener('wheel', preventScroll, { passive: false });
  window.addEventListener('touchmove', preventScroll, { passive: false });
  window.addEventListener('keydown', preventScrollKeydown);
};

export const clearForceLockScroll = (): void => {
  window.removeEventListener('wheel', preventScroll);
  window.removeEventListener('touchmove', preventScroll);
  window.removeEventListener('keydown', preventScrollKeydown);
};
